import AppStoreButtons from "components/downloadappcta/appstorebuttons/AppStoreButtons";
import { t } from "i18n/index";
import { useMarketingLang } from "i18n/useMarketingLang";
import { getChromeTranslations } from "../marketing/i18n/pages/chrome";

const DownloadAppCTA = () => {
  const lang = useMarketingLang();
  const translations = getChromeTranslations(lang);
  return (
    <div className="download-app">
      <p>{t(translations, "featureChrome.orDownloadTheApp", "or download the app")}</p>
      <AppStoreButtons />
    </div>
  );
};

export default DownloadAppCTA;
